import axios from 'axios';
import router from '../router';
import store from '../store';
import { LOGOUT } from '../store/actions.type';

import { getToken } from '../services/jwtService';

const baseURL = (process.env.VUE_APP_ROOT_API || process.env.DEFAULT_API).trim();

function getInitializedApi(config) {
  const axiosConfig = {
    baseURL,
    responseType: 'json',
    headers: {},
    ...config,
  };

  const token = getToken();
  if (token && token !== '') {
    axiosConfig.headers.Authorization = `Bearer ${token}`;
  }

  const { tenantId } = store.getters;
  if (tenantId && tenantId !== '') {
    axiosConfig.headers['X-TenantId'] = tenantId;
  }

  const api = axios.create(axiosConfig);

  api.interceptors.response.use(undefined, (err) => new Promise(() => {
    if (err.response.status === 401 && !!err.response.config && !err.response.config.__isRetryRequest) {
      if (store.getters.isLoggedIn) {
        store.dispatch(LOGOUT);
        router.push('/');
      }
    }
    throw err;
  }));

  return api;
}

class Api {
  get(url, params) {
    return getInitializedApi().get(url, params);
  }

  getAllPages(url, params = {}) {
    return new Promise((resolve) => {
      const api = getInitializedApi();
      params.pageSize = 0;
      api.get(url, { params }).then((emptyResponse) => {
        const afterGet = { pageSize: emptyResponse.data.totalItems };
        api.get(url, { params: afterGet }).then((response) => {
          resolve(response);
        });
      });
    });
  }

  post(url, params) {
    return getInitializedApi().post(url, params);
  }

  put(url, params) {
    return getInitializedApi().put(url, params);
  }

  delete(url, params) {
    return getInitializedApi().delete(url, params);
  }
}

export default new Api();
